import { defineMessages } from 'react-intl';
import { EPassengerTitle } from '../../../common/types';
import {
  CANCEL_ORDER,
  CANCELLED_ORDERS,
  CURRENT_ORDERS,
  DOWNLOAD_TICKETS,
  EDIT_ORDER,
  NO_DISCOUNT_CARD,
  OPEN_ORDER_DETAILS,
  ORDER_ID,
  ORDER_ID_COPIED,
  ordersScope,
  PAGE_TITLE,
  PASSENGER,
  PASSENGERS,
  PAST_ORDERS,
  TOTAL_PRICE,
} from '../constants';

export const ordersMessages = {
  [PAGE_TITLE]: {
    id: `${ordersScope}.${PAGE_TITLE}`,
    defaultMessage: 'Mes billets',
    en: 'My orders',
    it: 'I miei biglietti',
    es: 'Mis pedidos',
    de: 'Meine Tickets',
    nl: 'Mijn tickets',
  },
  [CURRENT_ORDERS]: {
    id: `${ordersScope}.${CURRENT_ORDERS}`,
    defaultMessage: 'Trajets à venir',
    en: 'Upcoming trips',
    it: 'Prossimi itinerari',
    es: 'Próximas rutas',
    de: 'Zukünftige Fahrten',
    nl: 'Komende routes',
  },
  [PAST_ORDERS]: {
    id: `${ordersScope}.${PAST_ORDERS}`,
    defaultMessage: 'Trajets effectués',
    en: 'Past trips',
    it: 'Viaggi effettuati',
    es: 'Viajes realizados',
    de: 'Durchgeführte Fahrten',
    nl: 'Gemaakte reizen',
  },
  [CANCELLED_ORDERS]: {
    id: `${ordersScope}.${CANCELLED_ORDERS}`,
    defaultMessage: 'Trajets annulés',
    en: 'Cancelled trips',
    it: 'Viaggi annullati',
    es: 'Viajes cancelados',
    de: 'Stornierte Fahrten',
    nl: 'Geannuleerde reizen',
  },
  [ORDER_ID]: {
    id: `${ordersScope}.${ORDER_ID}`,
    defaultMessage: 'n° de commande : ',
    en: 'order number: ',
    it: "numero d'ordine:",
    es: 'número de pedido: ',
    de: 'Bestellnummer: ',
    nl: 'bestelnummer: ',
  },
  [OPEN_ORDER_DETAILS]: {
    id: `${ordersScope}.${OPEN_ORDER_DETAILS}`,
    defaultMessage: 'Voir le détail du voyage',
    en: 'See order details',
    it: 'Vedi i dettagli del viaggio',
    es: 'Ver los detalles del viaje',
    de: 'Reisedetails anzeigen',
    nl: 'Zie de details van de reis',
  },
  [DOWNLOAD_TICKETS]: {
    id: `${ordersScope}.${DOWNLOAD_TICKETS}`,
    defaultMessage: 'Télécharger mes billets',
    en: 'Download my tickets',
    it: 'Scarica i miei biglietti',
    es: 'Descargar mis entradas',
    de: 'Meine Tickets herunterladen',
    nl: 'Mijn tickets downloaden',
  },
  [TOTAL_PRICE]: {
    id: `${ordersScope}.${TOTAL_PRICE}`,
    defaultMessage: 'Prix total :',
    en: 'Total price:',
    it: 'Prezzo totale:',
    es: 'Precio total:',
    de: 'Gesamtpreis:',
    nl: 'Totale prijs:',
  },
  [ORDER_ID_COPIED]: {
    id: `${ordersScope}.${ORDER_ID_COPIED}`,
    defaultMessage: 'Copié !',
    en: 'Copied!',
    it: 'Ricevuto!',
    es: '¡Copiado!',
    de: 'Kopiert!',
    nl: 'Gekopieerd!',
  },
  [EDIT_ORDER]: {
    id: `${ordersScope}.${EDIT_ORDER}`,
    defaultMessage: 'Modifier la réservation',
    en: 'Modify the order',
    it: 'Modifica della prenotazione',
    es: 'Cambiar la reserva',
    de: 'Buchung ändern',
    nl: 'Wijzig reservering',
  },
  [CANCEL_ORDER]: {
    id: `${ordersScope}.${CANCEL_ORDER}`,
    defaultMessage: "Voir les conditions d'annulation",
    en: 'View cancellation conditions',
    it: 'Visualizza le condizioni di annullamento',
    es: 'Ver las condiciones de cancelación',
    de: 'Stornierungsbedingungen ansehen',
    nl: 'Annuleringsvoorwaarden bekijken',
  },
  [PASSENGER]: {
    id: `${ordersScope}.${PASSENGER}`,
    defaultMessage: 'Passager',
    en: 'Passenger',
    it: 'Passeggero',
    es: 'Pasajeros',
    de: 'Passagier',
    nl: 'Passagier',
  },
  [PASSENGERS]: {
    id: `${ordersScope}.${PASSENGERS}`,
    defaultMessage: 'Passagers',
    en: 'Passengers',
    it: 'Passeggero',
    es: 'Pasajeros',
    de: 'Passagiere',
    nl: 'Passagier',
  },
  [NO_DISCOUNT_CARD]: {
    id: `${ordersScope}.${NO_DISCOUNT_CARD}`,
    defaultMessage: 'Pas de carte de réduction',
    en: 'No discount card',
    it: 'Nessuna carta sconti',
    es: 'Sin tarjeta de descuento',
    de: 'Keine Ermäßigungskarte',
    nl: 'Geen kortingskaart',
  },
  [EPassengerTitle.MR]: {
    id: `${ordersScope}.${EPassengerTitle.MR}`,
    defaultMessage: 'M.',
    en: 'Mr.',
    it: 'Sig.',
    es: 'Sr.',
    de: 'Herr.',
    nl: 'Mr.',
  },
  [EPassengerTitle.MS]: {
    id: `${ordersScope}.${EPassengerTitle.MS}`,
    defaultMessage: 'Mme.',
    en: 'Ms.',
    it: 'Sig.ra',
    es: 'Sra.',
    de: 'Frau.',
    nl: 'Mevrouw.',
  },
  [EPassengerTitle.MX]: {
    id: `${ordersScope}.${EPassengerTitle.MX}`,
    defaultMessage: 'Mx.',
    en: 'Mx.',
    it: 'Mx.',
    es: 'Mx.',
    de: 'Mx.',
    nl: 'Mx.',
  },

  LOGOUT: {
    id: `${ordersScope}.LOGOUT`,
    defaultMessage: 'Se déconnecter',
    en: 'Logout',
    it: 'Disconnessionea',
    es: 'Desconectando',
    de: 'Sich abmelden',
    nl: 'Loskoppelen',
  },
  logoutInProgress: {
    id: `${ordersScope}.logoutInProgress`,
    defaultMessage: 'Déconnexion en cours',
    en: 'Logout in progress',
    es: 'Cierre de sesión en curso',
    it: 'Disconnessione in corso',
    de: 'Abmeldung läuft',
    nl: 'Uitloggen bezig',
  },
  bookHotel: {
    id: `${ordersScope}.bookHotel`,
    defaultMessage: 'Réserver un hôtel',
    en: 'Book a hotel',
    it: 'Prenota un hotel',
    es: 'Reservar un hotel',
    de: 'Hotel buchen',
    nl: 'Hotel boeken',
  },
  cfarTitle: {
    id: `${ordersScope}.cfarTitle`,
    defaultMessage: 'Option remboursement',
    en: 'Refund option',
    it: 'Opzione rimborso',
    es: 'Opción de reembolso',
    de: 'Erstattungsoption',
    nl: 'Terugbetalingsoptie',
  },
  cfarDeadline: {
    id: `${ordersScope}.cfarDeadline`,
    defaultMessage:
      '{trip} · demande possible jusqu’au {date} · {refund} remboursés',
    en: '{trip} · request it until {date} · {refund} refunded',
    it: '{trip} · richiesta possibile fino al {date} · {refund} rimborsati',
    es: '{trip} · solicitud posible hasta el {date} · {refund} reembolsados',
    de: '{trip} · Antrag möglich bis {date} · {refund} erstattet',
    nl: '{trip} · aanvragen kan tot {date} · {refund} terugbetaald',
  },
  cfarRequest: {
    id: `${ordersScope}.cfarRequest`,
    defaultMessage: 'Faire ma demande',
    en: 'Make my request',
    it: 'Fai la mia richiesta',
    es: 'Hacer mi solicitud',
    de: 'Antrag stellen',
    nl: 'Mijn aanvraag doen',
  },
  cfarCancelDeadline: {
    id: `${ordersScope}.cfarCancelDeadline`,
    defaultMessage:
      '{trip} · annulez sans justificatif jusqu’au {date} : {refund} remboursés',
    en: '{trip} · cancel with no proof until {date}: {refund} refunded',
    it: '{trip} · annulla senza giustificativo fino al {date}: {refund} rimborsati',
    es: '{trip} · cancela sin justificante hasta el {date}: {refund} reembolsados',
    de: '{trip} · ohne Nachweis stornieren bis {date}: {refund} erstattet',
    nl: '{trip} · annuleer zonder bewijs tot {date}: {refund} terugbetaald',
  },
  cfarCancel: {
    id: `${ordersScope}.cfarCancel`,
    defaultMessage: 'Annuler mon billet',
    en: 'Cancel my ticket',
    it: 'Annulla il mio biglietto',
    es: 'Cancelar mi billete',
    de: 'Mein Ticket stornieren',
    nl: 'Mijn ticket annuleren',
  },
  cfarConfirmTitle: {
    id: `${ordersScope}.cfarConfirmTitle`,
    defaultMessage: 'Annuler votre billet {trip} ?',
    en: 'Cancel your ticket {trip}?',
    it: 'Annullare il tuo biglietto {trip}?',
    es: '¿Cancelar tu billete {trip}?',
    de: 'Ihr Ticket {trip} stornieren?',
    nl: 'Uw ticket {trip} annuleren?',
  },
  cfarConfirmText: {
    id: `${ordersScope}.cfarConfirmText`,
    defaultMessage:
      'Le billet est annulé chez le transporteur et ne sera plus valable. Vous êtes remboursé de {refund} sur votre carte, sous 3 à 5 jours. Le prix de l’option n’est pas remboursé.',
    en: 'The carrier cancels the ticket and it will no longer be valid. You get {refund} back on your card, within 3 to 5 days. The price of the option is not refunded.',
    it: 'Il biglietto viene annullato presso il vettore e non sarà più valido. Ricevi {refund} sulla tua carta, entro 3-5 giorni. Il prezzo dell’opzione non è rimborsato.',
    es: 'El transportista cancela el billete y dejará de ser válido. Recibes {refund} en tu tarjeta, en un plazo de 3 a 5 días. El precio de la opción no se reembolsa.',
    de: 'Das Ticket wird beim Beförderer storniert und ist nicht mehr gültig. Sie erhalten {refund} auf Ihre Karte zurück, innerhalb von 3 bis 5 Tagen. Der Preis der Option wird nicht erstattet.',
    nl: 'De vervoerder annuleert het ticket en het is niet meer geldig. U krijgt {refund} terug op uw kaart, binnen 3 tot 5 dagen. De prijs van de optie wordt niet terugbetaald.',
  },
  cfarConfirm: {
    id: `${ordersScope}.cfarConfirm`,
    defaultMessage: 'Confirmer l’annulation',
    en: 'Confirm the cancellation',
    it: 'Conferma l’annullamento',
    es: 'Confirmar la cancelación',
    de: 'Stornierung bestätigen',
    nl: 'Annulering bevestigen',
  },
  cfarKeep: {
    id: `${ordersScope}.cfarKeep`,
    defaultMessage: 'Garder mon billet',
    en: 'Keep my ticket',
    it: 'Tieni il mio biglietto',
    es: 'Mantener mi billete',
    de: 'Ticket behalten',
    nl: 'Mijn ticket houden',
  },
  cfarCancelled: {
    id: `${ordersScope}.cfarCancelled`,
    defaultMessage:
      'Annulation enregistrée : {refund} remboursés sous 3 à 5 jours.',
    en: 'Cancellation recorded: {refund} refunded within 3 to 5 days.',
    it: 'Annullamento registrato: {refund} rimborsati entro 3-5 giorni.',
    es: 'Cancelación registrada: {refund} reembolsados en un plazo de 3 a 5 días.',
    de: 'Stornierung erfasst: {refund} werden innerhalb von 3 bis 5 Tagen erstattet.',
    nl: 'Annulering geregistreerd: {refund} terugbetaald binnen 3 tot 5 dagen.',
  },
  cfarDeadlinePassed: {
    id: `${ordersScope}.cfarDeadlinePassed`,
    defaultMessage:
      'Le délai est dépassé : l’option permettait d’annuler jusqu’au {date}.',
    en: 'The deadline is over: the option let you cancel until {date}.',
    it: 'Il termine è scaduto: l’opzione permetteva di annullare fino al {date}.',
    es: 'El plazo ha vencido: la opción permitía cancelar hasta el {date}.',
    de: 'Die Frist ist abgelaufen: Die Option erlaubte die Stornierung bis {date}.',
    nl: 'De termijn is verstreken: met de optie kon u annuleren tot {date}.',
  },
  cfarClaimLimit: {
    id: `${ordersScope}.cfarClaimLimit`,
    defaultMessage:
      'Vous avez déjà utilisé 2 options remboursement au cours des 12 derniers mois. Contactez notre service client.',
    en: 'You already used 2 refund options in the last 12 months. Contact our customer service.',
    it: 'Hai già usato 2 opzioni rimborso negli ultimi 12 mesi. Contatta il nostro servizio clienti.',
    es: 'Ya has usado 2 opciones de reembolso en los últimos 12 meses. Contacta con nuestro servicio de atención al cliente.',
    de: 'Sie haben in den letzten 12 Monaten bereits 2 Erstattungsoptionen genutzt. Kontaktieren Sie unseren Kundenservice.',
    nl: 'U heeft de afgelopen 12 maanden al 2 terugbetalingsopties gebruikt. Neem contact op met onze klantenservice.',
  },
  cfarSupportOnly: {
    id: `${ordersScope}.cfarSupportOnly`,
    defaultMessage:
      'Ce transporteur ne permet pas l’annulation en ligne. Faites votre demande : notre équipe la traite sous 48 h.',
    en: 'This carrier does not allow cancelling online. Make your request: our team handles it within 48 hours.',
    it: 'Questo vettore non permette l’annullamento online. Fai la tua richiesta: il nostro team la gestisce entro 48 ore.',
    es: 'Este transportista no permite cancelar en línea. Haz tu solicitud: nuestro equipo la gestiona en 48 h.',
    de: 'Dieser Beförderer erlaubt keine Online-Stornierung. Stellen Sie Ihren Antrag: Unser Team bearbeitet ihn innerhalb von 48 Stunden.',
    nl: 'Deze vervoerder staat online annuleren niet toe. Doe uw aanvraag: ons team behandelt die binnen 48 uur.',
  },
  cfarAlreadyCancelled: {
    id: `${ordersScope}.cfarAlreadyCancelled`,
    defaultMessage: 'Ce billet est déjà annulé.',
    en: 'This ticket is already cancelled.',
    it: 'Questo biglietto è già annullato.',
    es: 'Este billete ya está cancelado.',
    de: 'Dieses Ticket ist bereits storniert.',
    nl: 'Dit ticket is al geannuleerd.',
  },
  cfarError: {
    id: `${ordersScope}.cfarError`,
    defaultMessage:
      'Le transporteur n’a pas pu annuler votre billet. Faites votre demande au service client : nous la traitons sous 48 h.',
    en: 'The carrier could not cancel your ticket. Make your request to customer service: we handle it within 48 hours.',
    it: 'Il vettore non ha potuto annullare il tuo biglietto. Fai la tua richiesta al servizio clienti: la gestiamo entro 48 ore.',
    es: 'El transportista no ha podido cancelar tu billete. Haz tu solicitud al servicio de atención al cliente: la gestionamos en 48 h.',
    de: 'Der Beförderer konnte Ihr Ticket nicht stornieren. Stellen Sie Ihren Antrag beim Kundenservice: Wir bearbeiten ihn innerhalb von 48 Stunden.',
    nl: 'De vervoerder kon uw ticket niet annuleren. Doe uw aanvraag bij de klantenservice: wij behandelen die binnen 48 uur.',
  },
  cfarCheckError: {
    id: `${ordersScope}.cfarCheckError`,
    defaultMessage:
      'Nous n’avons pas pu vérifier l’annulation de ce billet. Réessayez dans quelques instants.',
    en: 'We could not check the cancellation of this ticket. Try again in a few moments.',
    it: 'Non abbiamo potuto verificare l’annullamento di questo biglietto. Riprova tra qualche istante.',
    es: 'No hemos podido comprobar la cancelación de este billete. Vuelve a intentarlo en unos instantes.',
    de: 'Wir konnten die Stornierung dieses Tickets nicht prüfen. Versuchen Sie es in einigen Augenblicken erneut.',
    nl: 'We konden de annulering van dit ticket niet controleren. Probeer het over enkele ogenblikken opnieuw.',
  },
  cfarNoProduct: {
    id: `${ordersScope}.cfarNoProduct`,
    defaultMessage: 'L’option remboursement n’est plus active sur ce billet.',
    en: 'The refund option is no longer active on this ticket.',
    it: 'L’opzione rimborso non è più attiva su questo biglietto.',
    es: 'La opción de reembolso ya no está activa en este billete.',
    de: 'Die Erstattungsoption ist für dieses Ticket nicht mehr aktiv.',
    nl: 'De terugbetalingsoptie is niet meer actief op dit ticket.',
  },
  zenRelaxActive: {
    id: `${ordersScope}.zenRelaxActive`,
    defaultMessage: 'Zen & Relax actif',
    en: 'Zen & Relax active',
    it: 'Zen & Relax attivo',
    es: 'Zen & Relax activo',
    de: 'Zen & Relax aktiv',
    nl: 'Zen & Relax actief',
  },
  zenRelaxOfferTitle: {
    id: `${ordersScope}.zenRelaxOfferTitle`,
    defaultMessage: 'Recevez votre voie et vos retards par SMS',
    en: 'Get your platform and delays by text',
    it: 'Ricevi binario e ritardi via SMS',
    es: 'Recibe tu vía y tus retrasos por SMS',
    de: 'Gleis und Verspätungen per SMS erhalten',
    nl: 'Ontvang uw spoor en vertragingen per sms',
  },
  zenRelaxOfferText: {
    id: `${ordersScope}.zenRelaxOfferText`,
    defaultMessage:
      'Avec Zen & Relax, nous vous envoyons la voie dès qu’elle est affichée, ses changements et les retards. Notre service client traite vos demandes en priorité.',
    en: 'With Zen & Relax, we text you the platform as soon as it shows, its changes and the delays. Our customer service handles your requests first.',
    it: 'Con Zen & Relax, ti inviamo il binario appena viene annunciato, i suoi cambi e i ritardi. Il nostro servizio clienti gestisce le tue richieste in priorità.',
    es: 'Con Zen & Relax, te enviamos la vía en cuanto se anuncia, sus cambios y los retrasos. Nuestro servicio de atención al cliente trata tus solicitudes con prioridad.',
    de: 'Mit Zen & Relax senden wir Ihnen das Gleis, sobald es angezeigt wird, seine Änderungen und die Verspätungen. Unser Kundenservice bearbeitet Ihre Anfragen vorrangig.',
    nl: 'Met Zen & Relax sturen we u het spoor zodra het bekend is, de wijzigingen en de vertragingen. Onze klantenservice behandelt uw vragen met voorrang.',
  },
  zenRelaxOfferTextWithDelayClaims: {
    id: `${ordersScope}.zenRelaxOfferTextWithDelayClaims`,
    defaultMessage:
      'Avec Zen & Relax, nous vous envoyons la voie dès qu’elle est affichée, ses changements et les retards. Dès 30 minutes de retard, nous demandons pour vous la compensation G30 à la SNCF. Notre service client traite vos demandes en priorité.',
    en: 'With Zen & Relax, we text you the platform as soon as it shows, its changes and the delays. From 30 minutes late, we ask SNCF for your G30 compensation. Our customer service handles your requests first.',
    it: 'Con Zen & Relax, ti inviamo il binario appena viene annunciato, i suoi cambi e i ritardi. Da 30 minuti di ritardo, chiediamo per te la compensazione G30 a SNCF. Il nostro servizio clienti gestisce le tue richieste in priorità.',
    es: 'Con Zen & Relax, te enviamos la vía en cuanto se anuncia, sus cambios y los retrasos. A partir de 30 minutos de retraso, pedimos por ti la compensación G30 a SNCF. Nuestro servicio de atención al cliente trata tus solicitudes con prioridad.',
    de: 'Mit Zen & Relax senden wir Ihnen das Gleis, sobald es angezeigt wird, seine Änderungen und die Verspätungen. Ab 30 Minuten Verspätung beantragen wir für Sie die G30-Entschädigung bei SNCF. Unser Kundenservice bearbeitet Ihre Anfragen vorrangig.',
    nl: 'Met Zen & Relax sturen we u het spoor zodra het bekend is, de wijzigingen en de vertragingen. Vanaf 30 minuten vertraging vragen wij voor u de G30-compensatie aan bij SNCF. Onze klantenservice behandelt uw vragen met voorrang.',
  },
  zenRelaxOfferButton: {
    id: `${ordersScope}.zenRelaxOfferButton`,
    defaultMessage: 'Ajouter pour {price}',
    en: 'Add for {price}',
    it: 'Aggiungi per {price}',
    es: 'Añadir por {price}',
    de: 'Für {price} hinzufügen',
    nl: 'Toevoegen voor {price}',
  },
  zenRelaxText: {
    id: `${ordersScope}.zenRelaxText`,
    defaultMessage:
      'Vos demandes sont traitées en priorité, et nous vous prévenons par SMS de la voie, des retards et des annulations de vos trains, quand le transporteur les publie.',
    en: 'Your requests are handled first, and we text you the platform, delays and cancellations of your trains, when the carrier publishes them.',
    it: 'Le tue richieste sono gestite in priorità e ti avvisiamo via SMS di binario, ritardi e cancellazioni dei tuoi treni, quando il vettore li pubblica.',
    es: 'Tus solicitudes se tratan con prioridad y te avisamos por SMS de la vía, los retrasos y las cancelaciones de tus trenes, cuando el transportista los publica.',
    de: 'Ihre Anfragen werden vorrangig bearbeitet, und wir informieren Sie per SMS über Gleis, Verspätungen und Ausfälle Ihrer Züge, sobald der Anbieter sie veröffentlicht.',
    nl: 'Uw vragen worden met voorrang behandeld en we sturen u een sms over het spoor, vertragingen en annuleringen van uw treinen, zodra de vervoerder ze publiceert.',
  },
  delayClaimToFile: {
    id: `${ordersScope}.delayClaimToFile`,
    defaultMessage:
      '{trip} · retard de {minutes} min : nous demandons votre compensation à SNCF, {amount} attendus',
    en: '{trip} · {minutes} min late: we are asking SNCF for your compensation, {amount} expected',
    it: '{trip} · ritardo di {minutes} min: chiediamo il tuo indennizzo a SNCF, {amount} previsti',
    es: '{trip} · retraso de {minutes} min: pedimos tu compensación a SNCF, {amount} previstos',
    de: '{trip} · {minutes} Min. Verspätung: Wir beantragen Ihre Entschädigung bei der SNCF, {amount} erwartet',
    nl: '{trip} · {minutes} min vertraging: wij vragen uw compensatie bij SNCF aan, {amount} verwacht',
  },
  delayClaimFiled: {
    id: `${ordersScope}.delayClaimFiled`,
    defaultMessage:
      '{trip} · retard de {minutes} min : compensation demandée le {date}, {amount} attendus',
    en: '{trip} · {minutes} min late: compensation asked on {date}, {amount} expected',
    it: '{trip} · ritardo di {minutes} min: indennizzo richiesto il {date}, {amount} previsti',
    es: '{trip} · retraso de {minutes} min: compensación solicitada el {date}, {amount} previstos',
    de: '{trip} · {minutes} Min. Verspätung: Entschädigung am {date} beantragt, {amount} erwartet',
    nl: '{trip} · {minutes} min vertraging: compensatie aangevraagd op {date}, {amount} verwacht',
  },
  connectedAs: {
    id: `${ordersScope}.connectedAs`,
    defaultMessage: 'Connecté avec {email}',
    en: 'Signed in as {email}',
    it: 'Connesso come {email}',
    es: 'Conectado como {email}',
    de: 'Angemeldet als {email}',
    nl: 'Ingelogd als {email}',
  },
  nextDeparture: {
    id: `${ordersScope}.nextDeparture`,
    defaultMessage: 'Prochain départ',
    en: 'Next departure',
    it: 'Prossima partenza',
    es: 'Próxima salida',
    de: 'Nächste Abfahrt',
    nl: 'Volgend vertrek',
  },
  later: {
    id: `${ordersScope}.later`,
    defaultMessage: 'Plus tard',
    en: 'Later',
    it: 'Più tardi',
    es: 'Más adelante',
    de: 'Später',
    nl: 'Later',
  },
  outbound: {
    id: `${ordersScope}.outbound`,
    defaultMessage: 'Aller',
    en: 'Outbound',
    it: 'Andata',
    es: 'Ida',
    de: 'Hinfahrt',
    nl: 'Heenreis',
  },
  return: {
    id: `${ordersScope}.return`,
    defaultMessage: 'Retour',
    en: 'Return',
    it: 'Ritorno',
    es: 'Vuelta',
    de: 'Rückfahrt',
    nl: 'Terugreis',
  },
  passengersCount: {
    id: `${ordersScope}.passengersCount`,
    defaultMessage: '{count, plural, one {# passager} other {# passagers}}',
    en: '{count, plural, one {# passenger} other {# passengers}}',
    it: '{count, plural, one {# passeggero} other {# passeggeri}}',
    es: '{count, plural, one {# pasajero} other {# pasajeros}}',
    de: '{count, plural, one {# Reisender} other {# Reisende}}',
    nl: '{count, plural, one {# reiziger} other {# reizigers}}',
  },
  direct: {
    id: `${ordersScope}.direct`,
    defaultMessage: 'Direct',
    en: 'Direct',
    it: 'Diretto',
    es: 'Directo',
    de: 'Direkt',
    nl: 'Direct',
  },
  connections: {
    id: `${ordersScope}.connections`,
    defaultMessage:
      '{count, plural, one {# correspondance} other {# correspondances}}',
    en: '{count, plural, one {# change} other {# changes}}',
    it: '{count, plural, one {# cambio} other {# cambi}}',
    es: '{count, plural, one {# transbordo} other {# transbordos}}',
    de: '{count, plural, one {# Umstieg} other {# Umstiege}}',
    nl: '{count, plural, one {# overstap} other {# overstappen}}',
  },
  presaleNote: {
    id: `${ordersScope}.presaleNote`,
    defaultMessage: "Billets émis à l'ouverture des ventes, envoyés par email.",
    en: 'Tickets issued when sales open, sent by email.',
    it: "Biglietti emessi all'apertura delle vendite, inviati per email.",
    es: 'Billetes emitidos al abrir las ventas, enviados por email.',
    de: 'Tickets werden bei Verkaufsstart ausgestellt und per E-Mail gesendet.',
    nl: 'Tickets worden uitgegeven bij de start van de verkoop en per e-mail verstuurd.',
  },
  pdfAfterIssue: {
    id: `${ordersScope}.pdfAfterIssue`,
    defaultMessage: 'PDF disponible après émission',
    en: 'PDF available once issued',
    it: "PDF disponibile dopo l'emissione",
    es: 'PDF disponible tras la emisión',
    de: 'PDF nach Ausstellung verfügbar',
    nl: 'PDF beschikbaar na uitgifte',
  },
  refunded: {
    id: `${ordersScope}.refunded`,
    defaultMessage: 'Remboursé',
    en: 'Refunded',
    it: 'Rimborsato',
    es: 'Reembolsado',
    de: 'Erstattet',
    nl: 'Terugbetaald',
  },
  refundedAmount: {
    id: `${ordersScope}.refundedAmount`,
    defaultMessage: 'Remboursé · {amount}',
    en: 'Refunded · {amount}',
    it: 'Rimborsato · {amount}',
    es: 'Reembolsado · {amount}',
    de: 'Erstattet · {amount}',
    nl: 'Terugbetaald · {amount}',
  },
  refundVoucher: {
    id: `${ordersScope}.refundVoucher`,
    defaultMessage: "Remboursé en bon d'achat {company}",
    en: 'Refunded with a {company} voucher',
    it: 'Rimborsato con un buono {company}',
    es: 'Reembolsado con un vale {company}',
    de: 'Erstattet als {company}-Gutschein',
    nl: 'Terugbetaald met een {company}-tegoedbon',
  },
  refundInProgress: {
    id: `${ordersScope}.refundInProgress`,
    defaultMessage: 'Remboursement en cours',
    en: 'Refund in progress',
    it: 'Rimborso in corso',
    es: 'Reembolso en curso',
    de: 'Erstattung läuft',
    nl: 'Terugbetaling bezig',
  },
  refundInProgressText: {
    id: `${ordersScope}.refundInProgressText`,
    defaultMessage: "Nous vous écrivons dès que c'est fait.",
    en: 'We will email you once it is done.',
    it: 'Ti scriveremo appena sarà fatto.',
    es: 'Te escribiremos en cuanto esté hecho.',
    de: 'Wir schreiben Ihnen, sobald es erledigt ist.',
    nl: 'We mailen u zodra het gedaan is.',
  },
  refundErrored: {
    id: `${ordersScope}.refundErrored`,
    defaultMessage: 'Remboursement à vérifier',
    en: 'Refund to check',
    it: 'Rimborso da verificare',
    es: 'Reembolso por verificar',
    de: 'Erstattung zu prüfen',
    nl: 'Terugbetaling te controleren',
  },
  refundErroredText: {
    id: `${ordersScope}.refundErroredText`,
    defaultMessage:
      'Contactez le service client, nous regardons votre dossier.',
    en: 'Contact customer service, we will look into it.',
    it: 'Contatta il servizio clienti, verificheremo la tua pratica.',
    es: 'Contacta con el servicio de atención al cliente, revisaremos tu caso.',
    de: 'Kontaktieren Sie den Kundenservice, wir prüfen Ihren Fall.',
    nl: 'Neem contact op met de klantenservice, wij bekijken uw dossier.',
  },
  emptyCurrentOrders: {
    id: `${ordersScope}.emptyCurrentOrders`,
    defaultMessage: 'Aucun trajet à venir',
    en: 'No upcoming trip',
    it: 'Nessun viaggio in programma',
    es: 'Ningún viaje próximo',
    de: 'Keine anstehende Reise',
    nl: 'Geen komende reis',
  },
  emptyPastOrders: {
    id: `${ordersScope}.emptyPastOrders`,
    defaultMessage: 'Aucun trajet effectué',
    en: 'No past trip',
    it: 'Nessun viaggio effettuato',
    es: 'Ningún viaje realizado',
    de: 'Keine vergangene Reise',
    nl: 'Geen afgelegde reis',
  },
  emptyCancelledOrders: {
    id: `${ordersScope}.emptyCancelledOrders`,
    defaultMessage: 'Aucune commande annulée',
    en: 'No cancelled order',
    it: 'Nessun ordine annullato',
    es: 'Ningún pedido cancelado',
    de: 'Keine stornierte Bestellung',
    nl: 'Geen geannuleerde bestelling',
  },
  emptyText: {
    id: `${ordersScope}.emptyText`,
    defaultMessage: 'Vos billets apparaîtront ici.',
    en: 'Your tickets will show here.',
    it: 'I tuoi biglietti appariranno qui.',
    es: 'Tus billetes aparecerán aquí.',
    de: 'Ihre Tickets erscheinen hier.',
    nl: 'Uw tickets verschijnen hier.',
  },
  searchTrip: {
    id: `${ordersScope}.searchTrip`,
    defaultMessage: 'Rechercher un trajet',
    en: 'Search a trip',
    it: 'Cerca un viaggio',
    es: 'Buscar un viaje',
    de: 'Reise suchen',
    nl: 'Reis zoeken',
  },
  missingTicket: {
    id: `${ordersScope}.missingTicket`,
    defaultMessage:
      "Un billet manque ? Vérifiez l'adresse email utilisée lors de l'achat.",
    en: 'A ticket is missing? Check the email address used for the purchase.',
    it: "Manca un biglietto? Verifica l'indirizzo email usato per l'acquisto.",
    es: '¿Falta un billete? Comprueba el email usado en la compra.',
    de: 'Fehlt ein Ticket? Prüfen Sie die beim Kauf verwendete E-Mail-Adresse.',
    nl: 'Ontbreekt er een ticket? Controleer het e-mailadres van de aankoop.',
  },
  supportQuestion: {
    id: `${ordersScope}.supportQuestion`,
    defaultMessage: 'Un souci avec une commande ?',
    en: 'A problem with an order?',
    it: 'Un problema con un ordine?',
    es: '¿Un problema con un pedido?',
    de: 'Ein Problem mit einer Bestellung?',
    nl: 'Een probleem met een bestelling?',
  },
  tripsTabs: {
    id: `${ordersScope}.tripsTabs`,
    defaultMessage: 'Mes trajets',
    en: 'My trips',
    it: 'I miei viaggi',
    es: 'Mis viajes',
    de: 'Meine Reisen',
    nl: 'Mijn reizen',
  },
  contactSupportCta: {
    id: `${ordersScope}.contactSupportCta`,
    defaultMessage: 'Contacter le service client',
    en: 'Contact customer service',
    it: 'Contatta il servizio clienti',
    es: 'Contactar con atención al cliente',
    de: 'Kundenservice kontaktieren',
    nl: 'Contact opnemen met de klantenservice',
  },
  tabCurrentOrders: {
    id: `${ordersScope}.tabCurrentOrders`,
    defaultMessage: 'À venir',
    en: 'Upcoming',
    it: 'In arrivo',
    es: 'Próximos',
    de: 'Anstehend',
    nl: 'Gepland',
  },
  tabPastOrders: {
    id: `${ordersScope}.tabPastOrders`,
    defaultMessage: 'Effectués',
    en: 'Past',
    it: 'Effettuati',
    es: 'Realizados',
    de: 'Vergangen',
    nl: 'Afgelegd',
  },
  tabCancelledOrders: {
    id: `${ordersScope}.tabCancelledOrders`,
    defaultMessage: 'Annulés',
    en: 'Cancelled',
    it: 'Annullati',
    es: 'Cancelados',
    de: 'Storniert',
    nl: 'Geannuleerd',
  },
};

export default defineMessages(ordersMessages);
